import React, { useEffect, useState } from 'react';
import { MessageSquare, X } from 'lucide-react';
const names = ['María González', 'Carlos Fernández', 'Lucía Martínez', 'Juan Pablo Rodríguez', 'Valentina López', 'Martín Sánchez', 'Camila Herrera', 'Diego Morales', 'Florencia Ruiz', 'Sebastián Torres'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showNotification = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setNotification({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimer = setTimeout(showNotification, 5000);
    // Subsequent random intervals between 8 and 12 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        setTimeout(showNotification, Math.random() * 4000 + 8000);
      }
    }, 12000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-up max-w-sm w-[calc(100%-2rem)] md:w-auto" data-id="element-131">
      <div className="bg-white shadow-2xl rounded-lg p-4 flex items-start gap-4 relative border border-slate-100" data-id="element-132">
        <div className="flex-shrink-0 mt-1" data-id="element-133">
          <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center" data-id="element-134">
            <MessageSquare className="w-5 h-5 text-amber-600" data-id="element-135" />
          </div>
        </div>
        <div className="flex-1 pr-6" data-id="element-136">
          <p className="text-[10px] font-bold text-slate-500 tracking-wider uppercase mb-1" data-id="element-137">
            ALGUIEN ACABA DE COMPRAR
          </p>
          <p className="text-sm font-bold text-slate-900 mb-0.5" data-id="element-138">
            Redacción de Puntos Periciales PRO
          </p>
          <p className="text-xs text-slate-600 mb-1" data-id="element-139">
            {notification.name} de {notification.city}
          </p>
          <p className="text-[10px] text-slate-400" data-id="element-140">Hace unos instantes</p>
        </div>
        <button onClick={() => setIsVisible(false)} className="absolute top-3 right-3 text-slate-400 hover:text-slate-600 transition-colors" data-id="element-141">
          <X className="w-4 h-4" data-id="element-142" />
        </button>
      </div>
    </div>;
}